import React, { useEffect, useRef, useState } from 'react';
import {
  Box,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Divider,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  Stack,
  Typography,
  TextField,
} from '@mui/material';
import * as xlsx from 'xlsx';
import { useBoolean } from '../../hooks/useBoolean';
import { getYears } from '../../utils/constCodeUtils';
import SalesMngCostStatsHqContainer from './SalesMngCostStatsHqContainer';
import SalesMngCostStatsEmpContainer from './SalesMngCostStatsEmpContainer';
import EmpModalContainer from '../common/form/modal/EmpModalContainer';
import SalesMngCostStatsSalesContainer from './SalesMngCostStatsSalesContainer';
import SalesmanSelectbox from '../../components/sales-mng-cost-stats/SalesmanSelectbox';

//----------------------------------------------------------------------

const staticsTypes = [
  { name: '전체', type: 'headquarter' },
  { name: '임직원 직접비', type: 'employee' },
  { name: '영업사원별 직접비', type: 'salesman' },
];

//----------------------------------------------------------------------
const SalesMngCostStatsContainer = () => {
  const hqTableRef = useRef();
  const empTableRef = useRef();
  const salesTableRef = useRef();
  const showEmpDialog = useBoolean();

  const [type, setType] = useState('headquarter');
  const [years, setYears] = useState(null);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedSalesman, setSelectedSalesman] = useState('');

  const handleChangeType = (event, newType) => {
    if (newType === '' || newType === null) {
      newType = 'headquarter';
    }
    setType(newType);
    searchClickHandler();
  };

  useEffect(() => {
    const arrYears = getYears(3, 1);
    setYears(arrYears);
  }, []);

  const handleChangeYear = (event) => {
    setSelectedYear(event.target.value);
  };

  const selectedEmployee = (emp) => {
    setSelectedUser(emp);
  };

  const onChangeSalesman = (usrUuid) => {
    console.log(usrUuid);
    setSelectedSalesman(usrUuid);
  };

  const handleReset = () => {
    setSelectedUser(null);
    setType('headquarter');
  };

  const handleDownExcel = () => {
    let el;
    let name;
    if (type === 'headquarter') {
      el = hqTableRef;
      name = '본부';
    } else if (type === 'employee') {
      el = empTableRef;
      name = '임직원';
    } else if (type === 'salesman') {
      el = salesTableRef;
      name = '영업사원별';
    }
    htmlToExcel(el.current, name);
  };

  const htmlToExcel = (tableEl, name) => {
    const wb = xlsx.utils.table_to_book(tableEl, {
      sheet: 'sheet1',
      raw: true,
    });
    xlsx.writeFile(wb, name + '.xlsx');
  };

  const searchClickHandler = () => {};

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', my: 2 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box sx={{ mr: 1, minWidth: 120 }}>
            <FormControl variant="standard" fullWidth>
              <InputLabel id="selected-year-label">기준년도</InputLabel>
              <Select
                labelId="selected-year-label"
                id="selected-year"
                value={selectedYear}
                label="년도"
                onChange={handleChangeYear}
              >
                {years &&
                  years.map((item, index) => (
                    <MenuItem key={index} value={item}>
                      {item}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
          </Box>
          {type === 'employee' && (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Box sx={{ width: '20%', textAlign: 'center' }}>
                <Typography variant="subtitle2">임직원</Typography>
              </Box>
              <Box>
                <TextField
                  size="small"
                  required={true}
                  variant="outlined"
                  fullWidth
                  id="usrNm"
                  name="usrNm"
                  value={selectedUser?.usrNm || ''}
                  disabled
                />
              </Box>
              <Box>
                <Button
                  variant="outlined"
                  color="info"
                  onClick={showEmpDialog.onTrue}
                >
                  선택
                </Button>
              </Box>
            </Stack>
          )}

          {type === 'salesman' && (
            <Stack
              direction="row"
              spacing={2}
              alignItems="center"
              sx={{
                py: 1,
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Box sx={{ width: '20%', textAlign: 'center' }}>
                <Typography variant="subtitle2">영업사원</Typography>
              </Box>
              <SalesmanSelectbox
                selectedUsrUuid={selectedSalesman}
                onChange={onChangeSalesman}
              />
            </Stack>
          )}
          <Box sx={{ mx: 1 }}>
            <ToggleButtonGroup
              size="small"
              color="primary"
              value={type}
              exclusive
              onChange={handleChangeType}
            >
              {staticsTypes.map((type, index) => (
                <ToggleButton key={index} value={type.type}>
                  {type.name}
                </ToggleButton>
              ))}
            </ToggleButtonGroup>
          </Box>
        </Box>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          {type === 'employee' && (
            <Box sx={{ mx: 1 }}>
              <Button variant="contained" color="info" onClick={handleReset}>
                임직원 초기화
              </Button>
            </Box>
          )}
          <Box>
            <Button
              variant="contained"
              color="success"
              onClick={handleDownExcel}
            >
              엑셀 다운로드
            </Button>
          </Box>
        </Box>
      </Box>
      <Divider sx={{ my: 1 }} />

      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        {type === 'headquarter' && (
          <SalesMngCostStatsHqContainer
            selectedYear={selectedYear}
            tableRef={hqTableRef}
          />
        )}

        {type === 'employee' && (
          <SalesMngCostStatsEmpContainer
            selectedYear={selectedYear}
            tableRef={empTableRef}
            selectedUser={selectedUser}
          />
        )}
        {type === 'salesman' && (
          <SalesMngCostStatsSalesContainer
            selectedYear={selectedYear}
            tableRef={salesTableRef}
            selectedUser={selectedSalesman}
          />
        )}
      </Box>
      {showEmpDialog.value && (
        <EmpModalContainer
          title="사원찾기"
          multi={false}
          open={showEmpDialog.value}
          handleClose={showEmpDialog.onFalse}
          selectedEmployee={selectedEmployee}
        />
      )}
    </Box>
  );
};
//----------------------------------------------------------------------
export default SalesMngCostStatsContainer;
